import { ViteReactSSG } from "vite-react-ssg";
import type { RouteRecord } from "vite-react-ssg";
import "@/styles/tokens.css";
import { Layout } from "@/components/Layout";

export const routes: RouteRecord[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import("@/pages/Home")).default }) },
      { path: "platform", lazy: async () => ({ Component: (await import("@/pages/Platform")).default }) },
      { path: "digital-twin", lazy: async () => ({ Component: (await import("@/pages/DigitalTwin")).default }) },
      { path: "book-demo", lazy: async () => ({ Component: (await import("@/pages/BookDemo")).default }) },
    ],
  },
];

export const createRoot = ViteReactSSG({ routes });
